var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hide-in-small-screens no-active-chat",attrs:{"data-testid":"text_noConversationSelected"}},[_vm._v(" Select a conversation to start chatting ")])
}
var staticRenderFns = []

export { render, staticRenderFns }